import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import Table from "../../../components/Admin/Table";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import {
  getTimesheets,
  getAllEmployeeList,
} from "../../../services/viewTimeSheet";
import {
  approveTimesheet,
  downloadExcel,
  rejectTimesheet,
} from "../../../services/timeSheetApproval";
import "./TimeSheets.css";
import { format } from "date-fns";
import { appInsights } from "../../../AppInsights";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../components/Spinner/spinner";
const TimeSheetsAdmin = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date()?.getMonth());
  const { userData } = useSelector(state => state.user);
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  const [selectedProjectType, setSelectedProjectType] = useState("all");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [timesheets, setTimesheets] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [submitting, setSubmitting] = useState(false);
   const [selectedRowData, setSelectedRowData] = useState(null);
  const currentUserTypeId = localStorage.getItem("userTypeId");
  const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );
  const [showDownloadIcons, setShowDownloadIcons] = useState(false);
const roleId = currentUserRoleId?.userTypeRoleId
  const navigate = useNavigate();
  const toast = React.useRef(null);
  const [employeeFilter, setEmployeeFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [filteredData, setFilteredData] = useState();
  const projectTypes = [
    { label: "All Project Types", value: "all" },
    { label: "External Projects", value: "external" },
    { label: "Internal Projects", value: "internal" },
  ];

  const periodTypes = [
    { label: "All Period Types", value: "all" },
    { label: "Bi-Weekly", value: 2 },
    { label: "Monthly", value: 3 },
    { label: "Weekly", value: 1 },
  ];

  const months = [
    { label: "All Months", value: "all" },
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];
 let year = [
        { label: 'All Years', value: null },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
    ];
    const currentYear = new Date().getFullYear();
    if (!year.some(y => y.value === currentYear)) {
        year.push({ label: currentYear.toString(), value: currentYear });
    }
  const statusOptions = [
    { label: "All Status", value: "all" },
    { label: "Approved", value: "approved" },
    { label: "Pending", value: "pending" },
    { label: "Rejected", value: "rejected" },
  ];
const [page, setPage] = useState(1);
const [rowCount, setRowCount] = useState(50); // default rows per page

  useEffect(() => {
    if (timesheets) {
      let data = timesheets;

      // Apply status filter
      if (selectedStatus && selectedStatus !== "all") {
        data = data?.filter(
          (ts) => ts?.status?.toLowerCase() === selectedStatus
        );
      }

      // Apply project type filter
      if (selectedProjectType && selectedProjectType !== "all") {
        if (selectedProjectType?.toLowerCase() === "internal") {
          data = data?.filter((ts) => ts?.userTypeId == 1);
        } else if (selectedProjectType?.toLowerCase() === "external") {
          data = data?.filter((ts) => ts?.userTypeId == 2);
        }
      }

      // Apply employee filter
      if (selectedEmployee) {
        data = data?.filter((ts) => ts?.userId === selectedEmployee?.value);
      }

      setFilteredData(data);
    }
  }, [timesheets, selectedStatus]);

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    fetchTimesheets();
  }, [
    selectedEmployee,
    selectedMonth,
    selectedProjectType,
    selectedPeriodType,
    selectedYear,
    page,
    rowCount
  ]);

  const fetchEmployees = async () => {
    try {
      const response = await getAllEmployeeList();
      const employeeOptions = [
        { label: "All Employees", value: "all" },
        ...response?.map((emp) => ({
          label: emp?.userName
            ?.split(" ")
            .map(
              (word) =>
                word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
            )
            .join(" "),
          value: emp?.userId,
        })),
      ];
      setEmployees(employeeOptions);
    } catch (error) {
      appInsights.trackException("Get TimeSheets Employees", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
      });
    }
  };
  const formatDateForDisplay = (date) => {
    return format(new Date(date), "MM/dd/yy");
  };
  const [totalRecords,setTotalRecords]=useState(0);
  const fetchTimesheets = async () => {
    try {
      setLoading(true);
      const userId = selectedEmployee === "all" ? "all" : selectedEmployee;
      const monthId = selectedMonth === "all" ? null : selectedMonth;
      const projectTypeId =
        selectedProjectType === "all"
          ? null
          : selectedProjectType === "internal"
          ? 1
          : 2;
      const periodType =
        selectedPeriodType === "all" ? "all" : selectedPeriodType;
        
      const selectedYearId =  selectedYear && !selectedYear.label ? selectedYear : null;;
      const response = await getTimesheets(
        selectedYearId,
        userId,
        monthId,
        1,
        projectTypeId,
        periodType,
        page,
        rowCount
      );
      let formattedTimesheets = response?.timesheetData?.map((ts) => ({
        id: ts?.id,
        userId: ts?.userId,
        approvedBy: ts?.approvedBy,
        rejectedBy: ts?.rejectedBy,
        createdDate:ts?.createdDate,
        employeeName: ts?.userName
          ?.split(" ")
          .map(
            (word) =>
              word?.charAt(0)?.toUpperCase() + word?.slice(1).toLowerCase()
          )
          .join(" "),
        periodType: ts?.timesheetType,
        documents:ts?.documents,
        periodRange: ts?.startDate && ts?.endDate
        ? `${formatDateForDisplay(ts?.startDate)} - ${formatDateForDisplay(ts?.endDate)}`
        : "",
        hours: ts?.totalHours,
        status: ts?.status?.toLowerCase(),
        blobPath: ts?.blobPath,
        projects:ts?.projects,
        userTypeId: ts?.userTypeId,
        email: ts?.email,
        rejectionReason: ts?.rejectionReason,
      }));

      setTotalRecords(response?.timesheetCount)

      setTimesheets(formattedTimesheets);
    } catch (error) {
      appInsights.trackException("Get TimeSheets", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "Something went wrong at Server Side",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "employeeName",
      header: "Employee Name",
      sortable: true,
      type: "subText",
      frozen:true
    },
    { field: "periodType", header: "Period Type",  },
    { field: "periodType", header: "Project Type",type:'projectType'  },
    { field: "projects", header: "Projects",type:'projects1'  },
    { field: "periodRange", header: "Period Range", sortable: true },
    { field: "createdDate", header: "Created Date",type:"date"  },
    { field: "approvedBy", header: "Approved By" },
    { field: "rejectedBy", header: "Rejected By" },
    { field: "hours", header: "Hours" },
    { field: "rejectionReason", header: "Rejection Reason"},
    { field: "status", header: "Status",type:'status'},
  ];

  const handleView = (rowData) => {
    roleId==2?navigate(`/hr/timesheet/${rowData.id}`):navigate(`/admin/timesheet/${rowData.id}`, { state: { from: "admin" } });
  };

  const handleDownload = (rowData) => {
    if (rowData) {
      window.open(rowData, "_blank");
    } else {
      toast?.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "No document available for download",
      });
    }
  };

    const renderDownloadOrViewIcon = () => {
      return (
        <Dialog
          visible={showDownloadIcons}
          onHide={() => setShowDownloadIcons(false)}
          header="Uploaded Documents"
          modal
          className="p-dialog-sm p-fluid headerForProjectList"
          style={{ width: "50vw", maxWidth: "800px" }}
        >
          <div className="p-3 surface-section">
            <div className="flex flex-wrap gap-2">
              {selectedRowData?.documents.map((entry, index) => (
                <span
                  key={index}
                  className="bg-white border-round-2xl font-medium text-blue-900 p-2 p-tag"
                >
                  <Button
                    icon="pi pi-file"
                    text
                    severity="info"
                    className="btn-for-view"
                    tooltip={`Uploaded on ${formatDateForDisplay(entry?.createdDate)}`}
                    tooltipOptions={{ position: "top" }}
                    onClick={() => handleDownload(entry?.blobPath)}
                  />
                  <div className="block" style={{cursor:'pointer'}} onClick={() => handleDownload(entry?.blobPath)}>  {entry?.fileName}</div>
                  <Tooltip
                    target={`#download-link-${index}`}
                    content="Download"
                    position="top"
                  />
                </span>
              ))}
            </div>
          </div>
        </Dialog>
      );
    };



  const confirmApprove = (rowData) => {
    if (rowData.status !== "pending") {
      toast?.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "Only pending timesheets can be approved",
      });
      return;
    }

    confirmDialog({
      message: "Are you sure you want to approve this timesheet?",
      header: "Confirm Approval",
      icon: "pi pi-check-circle",
      acceptClassName: "p-button-success",
      accept: () => handleApprove(rowData),
      reject: () => {},
    });
  };

  const handleApprove = async (rowData) => {
    try {
      setSubmitting(true);
      await approveTimesheet({
        timeSheetId: rowData?.id,
        statusId: 2, // Approved status
      });
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Timesheet approved successfully",
      });
      fetchTimesheets();
    } catch (error) {
      appInsights.trackException("Post TimeSheets", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const confirmReject = (rowData) => {
    if (rowData?.status !== "pending") {
      toast?.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "Only pending timesheets can be rejected",
      });
      return;
    }

    setSelectedTimesheet(rowData);
    setRejectReason("");
    setShowRejectDialog(true);
  };

  const handleReject = async () => {
    if (!rejectReason.trim()) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Please provide a reason for rejection",
      });
      return;
    }

    try {
      setSubmitting(true);
      await rejectTimesheet({
        timeSheetId: selectedTimesheet?.id,
        statusId: 3, // Rejected status
        reason: rejectReason.trim(),
      });
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Timesheet rejected successfully",
      });
      setShowRejectDialog(false);
      fetchTimesheets();
    } catch (error) {
      appInsights.trackException("Post TimeSheets", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const downloadBtn = () => {
    const projectTypeId =
      selectedProjectType === "all"
        ? null
        : selectedProjectType === "internal"
        ? 1
        : 2;
    const paginatorRight = (
      <div className="">
        <Button
          type="button"
          icon="pi pi-download"
          label="Download"
          className="p-button-outlined border-1 border-round surface-border"
          onClick={() => {
            handleDownloadExcel(selectedYear, selectedMonth, projectTypeId);
          }}
        />
      </div>
    );
    return paginatorRight;
  };
  const showIcon = ( rowData) => {
    // setSelectedProject(entries); // Stores the list of project entries
    setSelectedRowData(rowData); // Stores the whole row (optional use for name, etc.)
    setShowDownloadIcons(true); // Triggers dialog visibility
  };
  const handleDownloadExcel = async (year, month, userTypeId) => {
    try {
      if (typeof year !== "number" || typeof month !== "number") {
        //  TODO: add toast
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: `Please select a year and month before downloading`,
          life: 3000,
        });
        return;
      }
      const monthName = months?.filter((x) => x?.value == month);
      const { url, filename } = await downloadExcel(
        year,
        month,
        userTypeId,
        monthName[0]?.label
      );

      // Create a temporary <a> element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); // Set the filename from the response header
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the Blob URL after the download
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      //  TODO: add toast
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.message || error?.status == 400
            ? "Timesheet entries not found for the given month or year"
            : error?.status == 500
            ? "Internal Server Error"
            : "Error while fetching details",
        life: 3000,
      });
    }
  };

  const actions = {
    status: {
      label: "Status",
      enabled: false,
      onChange: () => {},
    },
    download: {
      label: "Document",
      enabled: (rowData) => rowData,
      onClick: showIcon,
    },
    view: {
      label: "View",
      enabled: true,
      onClick: handleView,
    },
    approval: {
      label: "Actions",
      enabled: true,
      onApprove: confirmApprove,
      onReject: confirmReject,
    },
  };

  const renderHeader = () => {
    return (
      <div className="grid">
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedPeriodType}
            options={periodTypes}
            onChange={(e) => setSelectedPeriodType(e?.value)}
            placeholder="Period Type"
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedYear}
            options={year}
            onChange={(e) => setSelectedYear(e?.value)}
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedMonth}
            options={months}
            onChange={(e) => setSelectedMonth(e?.value)}
            placeholder="Month"
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedProjectType}
            options={projectTypes}
            onChange={(e) => setSelectedProjectType(e?.value)}
            placeholder="Project Type"
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <span className="p-input-icon-left w-full d-flex align-items-center">
            <div>
              <i className="pi pi-search" />
            </div>
            <Dropdown
              value={selectedEmployee}
              options={employees?.filter(
                (emp) =>
                  emp?.value === "all" ||
                  emp?.label
                    ?.toLowerCase()
                    .includes(employeeFilter?.toLowerCase())
              )}
              onChange={(e) => setSelectedEmployee(e?.value)}
              placeholder="Employee"
              className="w-full"
              filter
              filterValue={employeeFilter}
              onFilter={(e) => setEmployeeFilter(e.filter)}
              showClear
            />
          </span>
        </div>
        <div className="col-12">
          <div className="grid justify-content-end">
            <div className="col-12 md:col-3">
              <Dropdown
                value={selectedStatus}
                options={statusOptions}
                onChange={(e) => setSelectedStatus(e?.value)}
                placeholder="Select Status"
                className="w-full status-filter"
              />
            </div>
            <div className="col-12 md:col-2 download-div">{downloadBtn()}</div>
          </div>
        </div>
      </div>
    );
  };

  const tableStyle = {
    dataTable: "p-datatable-sm",
  };
  const [first,setFirst]=useState(1);
const onPageChange = (e) => {
  setRowCount(e?.rows);
  setPage(e?.page+1);
  setFirst(e?.first)
};

  return (
    <div className="timesheet-admin-container p-3 border-round-xl bg-white">
      <Toast ref={toast} />
      <ConfirmDialog className="adminRejectDialog" />
      {renderDownloadOrViewIcon()}
      <Dialog
        className="adminRejectDialog"
        visible={showRejectDialog}
        onHide={() => setShowRejectDialog(false)}
        header="Reject Timesheet"
        footer={
          <div>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setShowRejectDialog(false)}
              disabled={submitting}
            />
            <Button
              label="Reject"
              icon="pi pi-check"
              className="p-button-danger"
              onClick={handleReject}
              loading={submitting}
            />
          </div>
        }
      >
        <div className="flex flex-column gap-2">
          <label htmlFor="rejectReason">Reason for Rejection</label>
          <InputTextarea
            id="rejectReason"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            rows={3}
            className="w-full"
            placeholder="Enter reason for rejection"
          />
        </div>
      </Dialog>

      <div className="flex justify-content-between px-1 align-items-center">
        <div className="flex align-items-center p-2 gap-2">
          <h2 className="font-bold m-0 pl-2 pr-3 timesheet_heading">
            Timesheet List
          </h2>
          {totalRecords && (
            <span className="count-span pl-4 pr-4 p-2">
              {" "}
              {totalRecords}{" "}
            </span>
          )}
        </div>
      </div>
      <div className="table-container surface-section p-3 border-round-xl">
        <Table
          content={filteredData}
          columnsData={columns}
          actions={actions}
          tableStyle={tableStyle}
          header={renderHeader}
          paginator={true}
          //TODO:need make it dyanmaic
          totalRecords={totalRecords}
          first={first}
          onPage={onPageChange}
          rows={rowCount} 
          rowsPerPageOptions={[5, 10, 25, 50]}
          emptyMessage="No timesheets found"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          loading={loading}
        />
      </div>
        {loading && <Spinner />}
    </div>
  );
};

export default TimeSheetsAdmin;
